<template>
  <div class="line-item-summary__item line-item-summary__item--loading">
    <span v-if="adjustment.total">
      <div
        :class="[
          'coupon-code',
          { 'coupon-code--removable': adjustment.coupon_code },
        ]"
        style="color: #a2a2a6; font-weight: 400"
      >
        {{ adjustment.label }}
        <a
          v-if="adjustment.coupon_code && !calculating"
          class="coupon-code__removal"
          rel="nofollow"
          @click.prevent="removeCoupon"
        >
          <icon-cross :size="18" />
        </a></div
    ></span>
    <span v-if="adjustment.total">
      <div v-if="calculating">
        <three-dots-loading />
      </div>
      <div
        v-else
        :class="['line-item-summary__item-price', { discount: isDiscount }]"
      >
        {{ formatPrice(adjustment.total) }}
      </div>
    </span>
  </div>
</template>

<script>
import ThreeDotsLoading from '~/components/loadings/three-dots'
import priceable from '~/mixins/priceable'
import appendUrlParam from '~/utils/appendUrlParam'
import IconCross from '~/components/icons/cross/Cross'

export default {
  name: 'AdjustmentItem',
  components: {
    ThreeDotsLoading,
    IconCross,
  },
  mixins: [priceable],
  props: {
    adjustment: {
      type: Object,
      required: true,
    },
    isDiscount: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      calculating: false,
    }
  },
  methods: {
    async removeCoupon(e) {
      if (this.calculating) return
      e.preventDefault()

      const params = {
        ...this.$store.getters.storeInfo,
        coupon_code: this.adjustment.coupon_code,
      }

      this.calculating = true

      try {
        const result = await this.$apiv2.$post(
          appendUrlParam('coupons/remove', params)
        )
        this.$displayTopMessage(result.message)
        this.$emit('updateCart', result.cart)
        this.$store.dispatch('cart/handleCouponRemoved', true)
      } catch (err) {
        const errorMessage = err?.response?.data?.message
        this.$displayTopMessage(errorMessage, {
          type: 'error',
        })
      } finally {
        this.calculating = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.line-item-summary__item-price.discount {
  color: $v4_color_primary;
}

.line-item-summary__item-price {
  width: 80px;
}

.line-item-summary__item {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  align-items: center;
  text-align: right;
  font-size: 15px;
  padding-bottom: 5px;
}

.coupon-code.coupon-code--removable {
  background-color: #e2e2e6;
  border-radius: 3px;
  padding: 4px 6px;
  display: flex;
  align-items: center;

  .coupon-code__removal {
    margin-left: 4px;
    vertical-align: bottom;

    svg {
      vertical-align: bottom;
      fill: #a2a2a6;
    }
  }
}

.coupon-code:hover {
  .coupon-code__removal {
    svg {
      fill: #333;
    }
  }
}
</style>
